import {BRANDS} from "../../Config/ApiUrl";
import {deleteAction, editAction} from "../../Helpers/TableAction";
import {createdFilter} from "../../Helpers/TableFIlter";
import {actionColumn, nameColumn, textColumn} from "../../Helpers/TableCommonColumn";
import DatatableHelperMixin from "../../Mixins/DatatableHelperMixin";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        return {
            options: {
                name: this.$allLabel('brands'),
                url: BRANDS,
                responsive: true,
                columns: [
                    nameColumn(),
                    textColumn(this.$totalLabel('products'), 'products_count'),
                    actionColumn(),
                ],
                filters: [
                    createdFilter()
                ],
                actionType: "dropdown",
                actions: [
                    editAction(this.$can('update_brands'), BRANDS),
                    deleteAction(this.$can('delete_brands'), BRANDS)
                ],
                rowLimit: 10,
                paginationType: "pagination"
            },
            isModalActive: false,
            selectedUrl: null,
            confirmationModalActive: false
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.key === 'edit') {
                this.isModalActive = true;
                this.selectedUrl = `${this.apiUrl.BRANDS}/${row.id}`
            }else {
                this.getAction(row, action, active)
            }
        }
    }
}